import React from 'react';
import {getHelmetForMetaTags} from '../../utils/epicGamesUtils';
import {Link} from 'react-router-dom';
import {useCmsData, PageData, getInitialCmsPageSharedValues} from 'epic-ue-shared';
import {generateRoutePath} from 'epic-ue-locale-mode';
import LoadIndicator from '../../components/common/loading/LoadIndicator';
import {UeThemeProvider, ueLightTheme} from 'epic-ue-theme';
import Error404 from './Error404';

const cmsUrlPattern = '/careers/job-not-found';

export interface JobNotFoundPageData extends PageData {
    errorCode: string;
    title1: string;
    title2: string;
    msg: string;
    buttonLink: string;
    buttonMsg: string;
}

const JobNotFound = (): JSX.Element => {
    const {cmsLoading, cmsLoadedEmpty, pageData} = useCmsData<JobNotFoundPageData>(cmsUrlPattern);

    if (cmsLoading) {
        return (
            <div className="JobNotFound">
                {getHelmetForMetaTags(pageData)}
                <LoadIndicator />
            </div>
        );
    }

    if (cmsLoadedEmpty) {
        return <Error404 />;
    }

    const {errorCode, title1, title2, msg, buttonLink, buttonMsg} = pageData;

    return (
        <UeThemeProvider theme={ueLightTheme}>
            <>
                <div id="errorpage">
                    <div className="error-box">
                        <div>
                            <h1>{errorCode}</h1>
                            <h2>
                                {title1}
                                {title2}
                            </h2>
                            <p>{msg}</p>
                            {buttonLink && buttonMsg && (
                                <Link
                                    to={generateRoutePath(buttonLink)}
                                    className="cta-button text-center">
                                    {buttonMsg}
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
            </>
        </UeThemeProvider>
    );
};

JobNotFound.getInitialSharedValues = getInitialCmsPageSharedValues(cmsUrlPattern);

export default JobNotFound;
